import React from 'react';
import PropTypes from 'prop-types';

import * as style from './ArticleCallOutCardDeck.module.scss';
import ArticleCallOutCard from '../ArticleCallOutCard';
import { clearAllTagsFromString } from '../../../utilities';

/**
 * A card deck to hold Call Out Cards (icon + title + text) placed in column.
 */
const ArticleCallOutCardDeck = (props) => {
  const { cardsList } = props;

  return (
    <div className={style.cardDeck}>
      {cardsList?.map((card, index) => (
        <ArticleCallOutCard
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          icon={card?.callOutBoxHorizontalIcon}
          title={card?.callOutBoxHorizontalHeading}
          text={clearAllTagsFromString(card?.callOutBoxHorizontalText)}
        />
      ))}
    </div>
  );
};

ArticleCallOutCardDeck.propTypes = {
  /** An array of cards */
  cardsList: PropTypes.arrayOf(
    PropTypes.shape({
      callOutBoxHorizontalIcon: PropTypes.string.isRequired,
      callOutBoxHorizontalHeading: PropTypes.string.isRequired,
      callOutBoxHorizontalText: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ArticleCallOutCardDeck;
